import { render, staticRenderFns } from "./send_check.vue?vue&type=template&id=1271fdf1&scoped=true&"
import script from "./send_check.vue?vue&type=script&lang=js&"
export * from "./send_check.vue?vue&type=script&lang=js&"
import style0 from "./send_check.vue?vue&type=style&index=0&id=1271fdf1&scoped=true&lang=less&"
import style1 from "./send_check.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271fdf1",
  null
  
)

export default component.exports